import { render } from "./moshavertahsili.vue?vue&type=template&id=250568a4"
import script from "./moshavertahsili.vue?vue&type=script&lang=js"
export * from "./moshavertahsili.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/royahayefarda-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__